<template>
  <div class="space-y-4">
    <input
      v-model="modelValue.name"
      :placeholder="$t('totalForm.placeholders.name')"
      class="input input-bordered w-full"
    />
    <input
      v-model="modelValue.email"
      :placeholder="$t('totalForm.placeholders.email')"
      type="email"
      class="input input-bordered w-full"
    />
    <p class="text-sm text-gray-500">{{ $t("totalForm.privacy") }}</p>
    <button
      :disabled="!modelValue.name || !modelValue.email"
      @click="emit('next')"
      class="btn btn-primary w-full"
    >
      {{ $t("totalForm.next") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: "next"): void;
}>();

const modelValue = defineModel<{
  name: string;
  email: string;
  need: string;
  subscribe: boolean;
}>();
</script>
<script lang="ts">
export default {};
</script>
